export default __webpack_public_path__ + "static/media/arcade-open.ddbb62c4.png";